import { lazy } from 'react';
import { lazyRetry } from '../../utils/utils';

export { default as BannerSection } from './BannerSection/BannerSection';
export { default as ContentSectionDropdown } from './ContentSectionDropdown/ContentSectionDropdown';
export { default as ContentSections } from './ContentSections/ContentSections';
export { default as GileSearchForm } from './GileSearchForm/GileSearchForm';
export { default as LogoSection } from './LogoSection/LogoSection';
export { default as PaymentForm } from './PaymentForm/PaymentForm';
export { default as PaymentFormRow } from './PaymentFormRow/PaymentFormRow';
export { default as PaymentModes } from './PaymentModes/PaymentModes';
export { default as HeaderSection } from './HeaderSection/HeaderSection';
export { default as PaymentSection } from './PaymentSection/PaymentSection';
export { default as RenderSectionImages } from './RenderSectionImages/RenderSectionImages';
export { default as RenderSectionParagraph } from './RenderSectionParagraph/RenderSectionParagraph';
export { default as SearchSection } from './SearchSection/SearchSection';
export { default as RewardSections } from './RewardSections/RewardSections';
export { default as SupportSections } from './SupportSections/SupportSections';
export { default as PaymentLinkExpiry } from './PaymentLinkExpiry/PaymentLinkExpiry';

export * from './tables';
export * from './TimedRedirection'
export * from './InfoList';

// lazy loaded components
export const CheckboxBlock = lazy(() => lazyRetry(() => import('./CheckboxBlock/CheckboxBlock'), './CheckboxBlock/CheckboxBlock'));
export const DynamicBlock = lazy(() => lazyRetry(() => import('./DynamicBlock/DynamicBlock'), './DynamicBlock/DynamicBlock'));
export const PaymentModesEdit = lazy(() => lazyRetry(() => import('./PaymentModesEdit/PaymentModesEdit'), './PaymentModesEdit/PaymentModesEdit'));
export const ReverseApiFlow = lazy(() => lazyRetry(() => import('./ReverseApiFlow/ReverseApiFlow'), './ReverseApiFlow/ReverseApiFlow'));
export const Workflow = lazy(() => lazyRetry(() => import('./Workflow/Workflow'), './Workflow/Workflow'));
